import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import ky from 'ky-universal';
import { makeAPIError, parseError } from "../utils";
import stargateMarketplaceMethods from "./stargate.marketplace";
import { StargateAPIErrorCode } from "./stargate.types";

var StargateAPI = /*#__PURE__*/function () {
  function StargateAPI(baseUrl) {
    _classCallCheck(this, StargateAPI);

    _defineProperty(this, "_api", void 0);

    _defineProperty(this, "marketplace", stargateMarketplaceMethods(this));

    this._api = ky.create({
      prefixUrl: baseUrl
    });
  }
  /**
   * Get available sites for the logged in Atlassian Account session
   * @throws {StargateAPIError}
   */


  _createClass(StargateAPI, [{
    key: "availableSites",
    value: function () {
      var _availableSites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(products) {
        var _yield$parseError, status, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this._api.post('available-sites', {
                  json: {
                    products: products
                  }
                }).json();

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                _context.next = 10;
                return parseError(_context.t0);

              case 10:
                _yield$parseError = _context.sent;
                status = _yield$parseError.status;
                response = _yield$parseError.response;
                throw makeAPIError({
                  name: 'AvailableSitesError',
                  code: status === 401 ? StargateAPIErrorCode.UNAUTHORIZED : StargateAPIErrorCode.UNKNOWN,
                  response: response
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function availableSites(_x) {
        return _availableSites.apply(this, arguments);
      }

      return availableSites;
    }()
    /**
     * Get whether a user has a permission for a particular resource
     * @throws {StargateAPIError}
     */

  }, {
    key: "permitted",
    value: function () {
      var _permitted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(permissionId, resourceId) {
        var _yield$parseError2, status, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this._api.post('permissions/permitted', {
                  json: {
                    permissionId: permissionId,
                    resourceId: resourceId
                  }
                }).json();

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                _context2.next = 10;
                return parseError(_context2.t0);

              case 10:
                _yield$parseError2 = _context2.sent;
                status = _yield$parseError2.status;
                response = _yield$parseError2.response;
                throw makeAPIError({
                  name: 'PermittedError',
                  code: status === 401 ? StargateAPIErrorCode.UNAUTHORIZED : StargateAPIErrorCode.UNKNOWN,
                  response: response
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function permitted(_x2, _x3) {
        return _permitted.apply(this, arguments);
      }

      return permitted;
    }()
  }]);

  return StargateAPI;
}();

export { StargateAPI as default };